import { maskAnimation } from './mask';

document.defaultView.addEventListener( 'DOMContentLoaded', () => {
	maskAnimation( 'archive-title__mask' );

	ScrollReveal().reveal( '.archive__container>.archive__item', {
		duration: 1200,
		delay: 600,
		viewFactor: 0.2,
		interval: 16,
		origin: 'bottom',
		distance: '60px',
		easing: 'ease-out',
		module: true,
		desktop: true,
	} );
} );
